import "./ShouldBuy.scss";
import React, { useEffect, useState, useRef , useContext} from "react";
import goggles from "./Goggles.json";
import Slider from "react-slick";
import { mobile } from "../../Services/Agent";
import { GA_VPush } from "../../Services/GoogleAnalytics";
import { Link } from "react-router-dom";
import { AppContext } from "../../stores/application.store";

export default function ShouldBuy() {
  let { inArticle, toggleArticle } = useContext(AppContext);
  const [article, setArticle] = useState(goggles.goggles);
  let [sliderIndex, setSliderIndex] = useState(0);

  // Slick settings
  const settingsSlick = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: mobile() ? "60px" : "60px",
    slidesToShow: mobile() ? 3 : 4,
    speed: mobile() ? 500 : 0,
    // lazyLoad: "ondemend",
    focusOnSelect: true,
    afterChange: (index) => {
      setSliderIndex(index);
      GA_VPush(window.location.origin + window.location.pathname + (window.location.pathname[window.location.pathname.length - 1] == "/" ? "" : "/") + "reality-check/what-you-should-buy/" + article[index].title , `בדיקת מציאות - מה שכדאי לקנות ${article[index].title}`)
      // console.log(sliderIndex);
    },
  };


  //Listening To Touch events
  useEffect(() => {
    const prevBtn = document.querySelector(".slick-prev");
    const nextBtn = document.querySelector(".slick-next");

    let touchstartX = 0;
    let touchstartY = 0;
    let touchendX = 0;
    let touchendY = 0;

    let gesuredZone = document.querySelector(".sb_main");

    gesuredZone.addEventListener(
      "touchstart",
      function (event) {
        touchstartX = event.changedTouches[0].screenX;
        touchstartY = event.changedTouches[0].screenY;
      },
      false
    );

    gesuredZone.addEventListener(
      "touchend",
      function (event) {
        touchendX = event.changedTouches[0].screenX;
        touchendY = event.changedTouches[0].screenY;
        handleGesure();
      },
      false
    );

    let imageArr = document.querySelectorAll(".sb_image");
    function handleGesure() {
      let swiped = "swiped: ";
      if (touchendX < touchstartX) {
        // Swiped Left
        // The carusel moved Right
        document.querySelector(".should_buy .slick-next").click();
      }
      if (touchendX > touchstartX) {
        // Swiped Right
        // The carusel moved left
        document.querySelector(".should_buy .slick-prev").click();
      }
    }

    // ipad air (landscape)
    // 768 - width
    // 1024 - height
    // ipad pro (landscape)
    // 1024 - width
    // 1366 - height 
    // alert(window.screen.width);
    // alert(window.screen.height);

  }, []);

  return (
    <section className="should_buy watch sec-4">
      <div className="sb_wrapper">
        <div className="sb_title">
          <div className="suitcase"></div>
          <div className="title_text">מה שכדאי לקנות</div>
        </div>
        <div className="sb_gallery_wrapper">
          <div className="sb_main">
            <div className={`main_image_${article[sliderIndex].image}`}></div>
            <div className="image_text_wrapper">
              <div
                className={`image_brand_${article[sliderIndex].image}`}
              ></div>
              <div className="image_title">{article[sliderIndex].title}</div>
              <div className="image_description">
                {article[sliderIndex].desc}
              </div>
              <Link to={"/5752355"}
                className="article_link"
                // target="_blank"
                onClick={() => toggleArticle()}
              >
                למדריך המלא
              </Link>
            </div>
          </div>
          <div className="sb_side">
            <Slider {...settingsSlick}>
              {article.map((a, index) => (
                <div key={index}>
                  <div className={`sb_image image_${a.image}`}></div>
                </div>
              ))}
            </Slider>
            <div className={`middle_slick_${article[sliderIndex].image}`}></div>
          </div>
        </div>
      </div>
    </section>
  );
}
